import React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  DialogTitle,
  Typography,
  Theme,
  Divider,
} from '@quillbot/design-system';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  dialogPaper: {
    color: 'black',
    maxWidth: '400px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '64px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '12px',
    },
  },
  dialogContainer: {
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-start',
    },
  },
  dialogScrollPaper: {
    [theme.breakpoints.up('sm')]: {
      maxHeight: 'calc(100% - 96px)',
    },
  },
  dialogContent: {
    padding: '0 12px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 4px',
    },
  },
  title: {
    color: theme.palette.text.primary,
    padding: '10px 24px',
    fontSize: '20px',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      padding: '10px 16px',
    },
  },
  typeContainer: {
    padding: '10px 12px 20px',
  },
  typeHeading: {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingBottom: '4px',
  },
  typeDesc: {},
}));

interface IProps {
  open: boolean;
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function TypesDialog(props: IProps) {
  const classes = useStyles(props);
  return (
    <Dialog
      maxWidth="xs"
      open={props.open}
      classes={{
        paper: classes.dialogPaper,
        scrollPaper: classes.dialogContainer,
        paperScrollPaper: classes.dialogScrollPaper,
      }}
      onClose={props.onClose}
      aria-labelledby="max-width-dialog-title"
    >
      <DialogTitle classes={{ root: classes.title }} id="max-width-dialog-title">
        <IconButton
          onClick={props.onClose}
          style={{
            padding: 0,
            position: 'absolute',
            right: '4px',
            top: '4px',
          }}
          size="large"
        >
          <CloseOutlinedIcon />
        </IconButton>
        Summarization Types
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container direction="column">
          <Grid item className={classes.typeContainer}>
            <Typography display="block" variant="body2">
              The Summarizer condenses articles, papers, and other documents into a bulleted Key
              Sentences list or in a new paragraph.{' '}
            </Typography>
          </Grid>
          <Divider style={{ height: '1px' }} flexItem />
          <Grid item className={classes.typeContainer}>
            <Typography display="block" className={classes.typeHeading}>
              Paragraph (Abstractive)
            </Typography>
            <Typography display="block" variant="body2">
              Generates a new cohesive paragraph from the source text.{' '}
            </Typography>
          </Grid>
          <Divider style={{ height: '1px' }} flexItem />
          <Grid item className={classes.typeContainer}>
            <Typography display="block" className={classes.typeHeading}>
              Key Sentences (Extractive)
            </Typography>
            <Typography display="block" variant="body2">
              Pulls the most important sentences directly from the source text.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
